<script>
import bem from '@/utils/bem';
import PageHeader from '@/components/ux/pageHeader/page-header.vue';
import FramesColor from '@/components/frames/color/FramesColor.vue';
import FramesSizes from '@/components/frames/sizes/FramesSizes.vue';
import DrillDownView
  from '@/components/frames/drilldown/DrillDownView.vue';

const b = bem('create-page');

const MODE_OPTIONS = [
  { value: 'templates', label: 'Templates' },
  { value: 'color', label: 'Colors' },
  { value: 'sizes', label: 'Sizes' },
];

export default {
  components: {
    PageHeader,
    FramesColor,
    FramesSizes,
    DrillDownView,
  },
  data() {
    return {
      mode: 'templates',
      modeOptions: MODE_OPTIONS,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
  },
};
</script>

<template>
  <PageHeader title="Photo art templates" />

  <div :class="b()">
    <!-- Top-level mode switcher -->
    <div :class="b('top-tabs')">
      <a-segmented
        v-model:value="mode"
        :options="modeOptions"
        size="large"
      />
    </div>

    <!-- Canva-style drill-down for Templates -->
    <div
      v-if="mode === 'templates'"
      :class="b('main')"
    >
      <DrillDownView />
    </div>

    <!-- Colors — unchanged -->
    <FramesColor v-if="mode === 'color'" />

    <!-- Sizes — unchanged -->
    <FramesSizes v-if="mode === 'sizes'" />
  </div>
</template>

<style src="./style.scss" scoped lang="scss" />
